import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class WeatherIconService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getWeatherIcon(
    weathercode: Int16Array | undefined,
    dayind: Int16Array | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const WeatherInfo: JSON = <JSON>(<unknown>{
      weathercode: weathercode,
      dayind: dayind,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetWeatherIcon',
      JSON.stringify(WeatherInfo),
      { headers: headers }
    );
  }
}
